import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TPricingApi } from './types';

export const pricing: TPricingApi = {
	getAvailablePlans: () =>
		http.get(endpoint.pricing.AVAILABLE_PLANS).then((response) => response.data),
	getCurrentPlan: () => http.get(endpoint.pricing.CURRENT_PLAN).then((response) => response.data),
	requestNewPlan: (payload) =>
		http.post(endpoint.pricing.REQUEST_NEW_PLAN, payload).then((response) => response.data),
	getRequestedPlan: () =>
		http.get(endpoint.pricing.REQUESTED_PLAN).then((response) => response.data),
};
